import { Link, useLocation } from 'react-router-dom';
import { areaForPath } from '../lib/sections';
import './Topbar.css';

type Props = {
  onOpenSearch: () => void;
};

const BACK_TO_APP_URL = 'https://app.schedata.ai';

export function Topbar({ onOpenSearch }: Props) {
  const area = areaForPath(useLocation().pathname);
  return (
    <header className="ds-top">
      <Link className="ds-brand" to="/" aria-label="Schedata docs home">
        <img
          src="/brand/schedata-mark-color.svg"
          alt=""
          className="ds-brand-mark"
          width={28}
          height={28}
        />
        <span className="ds-brand-wordmark">schedata</span>
        <span className="ds-brand-tag">docs</span>
      </Link>
      <nav className="ds-top-nav">
        <Link to="/" className={area === 'docs' ? 'active' : undefined}>
          Documentation
        </Link>
        <Link to="/api/api-overview" className={area === 'api' ? 'active' : undefined}>
          API
        </Link>
      </nav>
      <div className="ds-top-spacer"></div>
      <button
        type="button"
        className="ds-top-search"
        onClick={onOpenSearch}
        aria-label="Open search"
      >
        <i className="fa-solid fa-magnifying-glass"></i>
        <span className="ds-top-search-placeholder">Search docs…</span>
        <kbd>⌘K</kbd>
      </button>
      <a className="ds-top-action" href={BACK_TO_APP_URL}>
        <i className="fa-solid fa-arrow-left"></i> Back to app
      </a>
    </header>
  );
}
